import React, { ReactNode, useRef } from 'react';
import styled from '@emotion/styled';
import { TextField, Button, IconButton } from '@material-ui/core';
import { Autorenew, Clear } from '@material-ui/icons';
import { FormattedMessage, useIntl } from 'react-intl';
import { useMediaBreakpoint } from './useMedia';
import { useWindowHotkey } from './hotkeys';

interface SearchFieldProps {
    filter: string;
    setFilter: (v: string) => void;
    doSearch?: () => void;
    fieldLabel?: string;
    buttonLabel?: ReactNode;
    searchOnBlur?: boolean;
    noButton?: boolean;
    noClear?: boolean;
    small?: boolean;
    autoFocus?: boolean;
    fullWidth?: boolean;
    noFocusHotkey?: boolean;
}

const SearchWrapper = styled.div`
    display: flex;
    flex-flow: row;
    align-items: flex-end;
`;

export const SearchField = (props: SearchFieldProps) => {
    const doSearch = props.doSearch || (() => { });
    const isMobile = useMediaBreakpoint("down", "sm");
    const { formatMessage } = useIntl();

    const fieldRef = useRef(null);

    useWindowHotkey("alt+q", () => {
        if(!props.noFocusHotkey && fieldRef.current && (fieldRef.current as any).focus) {
            (fieldRef.current as any).focus();
        }
    }, {
        noPreventDefault: props.noFocusHotkey,
    });

    return (
        <SearchWrapper>
            <TextField
                inputRef={fieldRef}
                size={props.small ? "small" : "medium"}
                value={props.filter}
                onChange={e => props.setFilter(e.target.value)}
                onKeyPress={e => { if(e.key === "Enter") { doSearch(); }}}
                placeholder={props.fieldLabel || formatMessage({ id: "searchField.label" })}
                onBlur={props.searchOnBlur ? doSearch : () => { }}
                autoFocus={props.autoFocus}
                fullWidth={props.fullWidth}
                InputProps={(props.noClear || isMobile) ? {} : {
                    endAdornment: <IconButton style={{ visibility: props.filter ? "visible" : "hidden" }} size="small" onClick={() => props.setFilter("")}><Clear /></IconButton>
                }}
                />
            {!props.noButton && <Button color="primary"
                startIcon={<Autorenew />}
                onClick={!props.searchOnBlur ? doSearch : () => { }} >
                    {props.buttonLabel || <FormattedMessage id="searchField.buttonLabel" />}
            </Button>}
        </SearchWrapper>
    )
}
